/**
 * Desktop topbar search: "search pill" (review 2026-08-13, second pass -
 * replaces an earlier separate-toggle-button+panel attempt that looked
 * jumpy in review). template-parts/header/topbar.php renders the theme's
 * shared searchform.php completely unmodified; layout/_header.scss
 * positions that same .jr-red-searchform absolutely (right: 0) and
 * transitions its width between a button-sized "collapsed" state and a
 * full "open" one - see that file's comment for why the submit button
 * itself never moves between the two.
 *
 * Because there's no separate toggle element anymore, the shared form's
 * OWN submit button plays both roles depending on state:
 *   - collapsed: a click opens the pill and focuses the input, instead
 *     of submitting.
 *   - open: a click submits normally (real GET navigation) - unless the
 *     input is empty, in which case it closes the pill instead of
 *     submitting an empty query.
 * Esc and click-outside close it either way, same as the first attempt.
 */
function initTopbarSearch() {
  const wrapper = document.querySelector('.topbar__search');

  if (!wrapper) {
    return;
  }

  const field = wrapper.querySelector('.jr-red-searchform__field');
  const button = wrapper.querySelector('.jr-red-searchform__submit');

  if (!field || !button) {
    return;
  }

  // Starts collapsed (layout/_header.scss's body.js default) - the input
  // shouldn't be reachable by Tab until the pill is open.
  field.setAttribute('tabindex', '-1');
  button.setAttribute('aria-expanded', 'false');

  // The width transition only activates AFTER the collapsed initial state
  // has painted (double rAF): without this, every page load animates the
  // no-JS expanded width collapsing to the chip - especially visible right
  // after submitting from search.php's always-open form (review feedback,
  // 2026-08-13). CSS scopes the transition under .topbar__search--ready.
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      wrapper.classList.add('topbar__search--ready');
    });
  });

  function isOpen() {
    return wrapper.classList.contains('topbar__search--is-open');
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      e.stopPropagation();
      close();
    }
  }

  function onClickOutside(e) {
    if (!wrapper.contains(e.target)) {
      close();
    }
  }

  function open() {
    wrapper.classList.add('topbar__search--is-open');
    button.setAttribute('aria-expanded', 'true');
    field.removeAttribute('tabindex');
    field.focus();

    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('click', onClickOutside, true);
  }

  function close() {
    wrapper.classList.remove('topbar__search--is-open');
    button.setAttribute('aria-expanded', 'false');
    field.setAttribute('tabindex', '-1');
    button.focus();

    document.removeEventListener('keydown', onKeydown, true);
    document.removeEventListener('click', onClickOutside, true);
  }

  button.addEventListener('click', (e) => {
    if (!isOpen()) {
      e.preventDefault();
      open();
      return;
    }

    if (field.value.trim() === '') {
      e.preventDefault();
      close();
    }
    // Else: open with a non-empty query - let the click submit the form.
  });
}

export default initTopbarSearch;
